import React, { useEffect } from 'react'
import '../Styles/CardCredit.css'
import { gsap } from 'gsap'

const CreditCard = () => {
  useEffect(() => {
    const speed = 3
    const r = gsap.timeline({ repeat: -1 })
    const o = gsap.timeline({ repeat: -1 })
    const h = gsap.timeline({ repeat: -1 })

    const creditCard = document.querySelector('.credit-card')

    creditCard.addEventListener('mouseenter', () => {
      r.pause()
      o.pause()
      h.pause()
    })

    creditCard.addEventListener('mouseleave', () => {
      r.play()
      o.play()
      h.play()
    })

    r.to('#container-credit-card', {
      '--r': '180deg',
      '--p': '0%',
      duration: speed,
      ease: 'sine.in',
    })
    r.to('#container-credit-card', {
      '--r': '360deg',
      '--p': '100%',
      duration: speed,
      ease: 'sine.out',
    })
    o.to('#container-credit-card', {
      '--o': 1,
      duration: speed / 2,
      ease: 'power1.in',
    })
    o.to('#container-credit-card', {
      '--o': 0,
      duration: speed / 2,
      ease: 'power1.out',
    })
    h.to('#container-credit-card', {
      '--h': '100%',
      duration: speed / 2,
      ease: 'sine.in',
    })
    h.to('#container-credit-card', {
      '--h': '50%',
      duration: speed / 2,
      ease: 'sine.out',
    })
    h.to('#container-credit-card', {
      '--h': '0%',
      duration: speed / 2,
      ease: 'sine.in',
    })
    h.to('#container-credit-card', {
      '--h': '50%',
      duration: speed / 2,
      ease: 'sine.out',
    })
  }, [])

  return (
    <section id="card-section">
      <div id="container-credit-card">
        <div className="credit-card">
          <div className="front-card"></div>
          <div className="back-card"></div>
        </div>
      </div>
    </section>
  )
}

export default CreditCard
